module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "pg4sec1",
      "title": "Anatomy of a Letter"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("ANATOMY of a LETTER")])]), _vm._v(" "), _c('p', {
    staticClass: "centertal"
  }, [_c('i', [_vm._v("THE STRUCTURE OF A CHARACTER")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "453",
      "src": "images/f0004-01.jpg",
      "width": "544"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc989278","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Intsec3.vue
// module id = 90
// module chunks = 0